import { call, put } from 'redux-saga/effects'
import { getCandidateNotes, postCandidateNote, patchCandidateNote, deleteCandidateNote } from '../apiModules/candidateNotes'
import { candidateNoteEntities } from '../reducks'

export function* fetchCandidateNoteEntitiesSaga(hiringTeamId, params) {
  const response = yield call(getCandidateNotes, hiringTeamId, params)
  yield put(candidateNoteEntities.addCollection(response.result))
  return response
}

export function* createCandidateNoteEntitySaga(hiringTeamId, data) {
  const response = yield call(postCandidateNote, hiringTeamId, data)
  yield put(candidateNoteEntities.addItem(response.result.id, response.result))
  return response
}

export function* updateCandidateNoteEntitySaga(hiringTeamId, noteId, data) {
  const response = yield call(patchCandidateNote, hiringTeamId, noteId, data)
  yield put(candidateNoteEntities.updateItem(response.result.id, response.result))
  return response
}

export function* deleteCandidateNoteEntitySaga(hiringTeamId, teamNoteId) {
  const response = yield call(deleteCandidateNote, hiringTeamId, teamNoteId)
  yield put(candidateNoteEntities.deleteItem(teamNoteId))
  return response
}
